export default __webpack_public_path__ + "static/media/factory_viewer_hero.f5c3b8dc.jpg";